import { AIRCRAFT_COUNTABLE_FUEL_GAL, AIRCRAFT_COUNTABLE_FUEL_KG, AIRCRAFT_COUNTABLE_FUEL_LB, AIRCRAFT_COUNTABLE_FUEL_LITERS, AIRCRAFT_FUEL_COUNTABLES, countableTypeIsFuel, } from '../../fuelChain/countableFuel';
export const COUNTABLE_CHANGE_CONSUMPTION = 'consumption';
export const COUNTABLE_CHANGE_UPLIFT = 'uplift';
export const COUNTABLE_CHANGE_CORRECTION = 'correction';
export const COUNTABLE_CHANGE_MAINTENANCE = 'maintenance';
export const AIRCRAFT_COUNTABLE_TACH_TIME = 'TACH_TIME';
export const AIRCRAFT_COUNTABLE_HOBBS_TIME = 'HOBBS_TIME';
export const AIRCRAFT_COUNTABLE_FLIGHT_TIME = 'FLIGHT_TIME';
export const AIRCRAFT_COUNTABLE_ANY_FLIGHT_TIME = 'ANY_FLIGHT_TIME';
export const AIRCRAFT_COUNTABLE_LANDINGS = 'LANDINGS';
export const AIRCRAFT_COUNTABLE_CYCLES = 'CYCLES';
export const AIRCRAFT_COUNTABLE_CYCLES_L = 'CYCLES_L';
export const AIRCRAFT_COUNTABLE_CYCLES_R = 'CYCLES_R';
export const AIRCRAFT_COUNTABLE_OIL_LEGACY = 'OIL';
export const AIRCRAFT_COUNTABLE_OIL_QUARTS = 'OIL_QUARTS';
export const AIRCRAFT_COUNTABLE_OIL_PERCENT = 'OIL_PERCENT';
export const AIRCRAFT_COUNTABLE_OIL_L_LEGACY = 'OIL_L';
export const AIRCRAFT_COUNTABLE_OIL_R_LEGACY = 'OIL_R';
export const AIRCRAFT_COUNTABLE_OIL_L_QUARTS = 'OIL_L_QUARTS';
export const AIRCRAFT_COUNTABLE_OIL_R_QUARTS = 'OIL_R_QUARTS';
export const AIRCRAFT_COUNTABLE_OIL_L_PERCENT = 'OIL_L_PERCENT';
export const AIRCRAFT_COUNTABLE_OIL_R_PERCENT = 'OIL_R_PERCENT';
export const AIRCRAFT_COUNTABLE_PRIST = 'PRIST';
export const AIRCRAFT_COUNTABLE_TKS = 'TKS';
export const AIRCRAFT_COUNTABLE_OXYGEN = 'OXYGEN';
export const AIRCRAFT_COUNTABLES = [
    AIRCRAFT_COUNTABLE_TACH_TIME,
    AIRCRAFT_COUNTABLE_FLIGHT_TIME,
    AIRCRAFT_COUNTABLE_HOBBS_TIME,
    AIRCRAFT_COUNTABLE_LANDINGS,
    AIRCRAFT_COUNTABLE_CYCLES,
    AIRCRAFT_COUNTABLE_CYCLES_L,
    AIRCRAFT_COUNTABLE_CYCLES_R,
    AIRCRAFT_COUNTABLE_FUEL_GAL,
    AIRCRAFT_COUNTABLE_FUEL_LB,
    AIRCRAFT_COUNTABLE_FUEL_KG,
    AIRCRAFT_COUNTABLE_FUEL_LITERS,
    AIRCRAFT_COUNTABLE_OIL_QUARTS,
    AIRCRAFT_COUNTABLE_OIL_L_QUARTS,
    AIRCRAFT_COUNTABLE_OIL_R_QUARTS,
    AIRCRAFT_COUNTABLE_OIL_PERCENT,
    AIRCRAFT_COUNTABLE_OIL_L_PERCENT,
    AIRCRAFT_COUNTABLE_OIL_R_PERCENT,
    AIRCRAFT_COUNTABLE_TKS,
    AIRCRAFT_COUNTABLE_OXYGEN,
];
export const AIRCRAFT_UPLIFTABLES = [
    AIRCRAFT_COUNTABLE_OIL_QUARTS,
    AIRCRAFT_COUNTABLE_OIL_L_QUARTS,
    AIRCRAFT_COUNTABLE_OIL_R_QUARTS,
    AIRCRAFT_COUNTABLE_PRIST,
    AIRCRAFT_COUNTABLE_FUEL_LITERS,
    AIRCRAFT_COUNTABLE_TKS,
    AIRCRAFT_COUNTABLE_OXYGEN,
];
export const AIRCRAFT_FLIGHT_TIME_COUNTABLES = [
    AIRCRAFT_COUNTABLE_FLIGHT_TIME,
    AIRCRAFT_COUNTABLE_TACH_TIME,
];
export { AIRCRAFT_COUNTABLE_FUEL_GAL, AIRCRAFT_COUNTABLE_FUEL_KG, AIRCRAFT_COUNTABLE_FUEL_LB, AIRCRAFT_COUNTABLE_FUEL_LITERS, AIRCRAFT_FUEL_COUNTABLES, countableTypeIsFuel, };
export const FUEL_LITERS_TO_GAL = 0.264172;
export const FUEL_LITERS_TO_LB = 1.7688;
export const FUEL_LITERS_TO_KG = 0.804;
export const AIRCRAFT_IGNORED_CONSUMABLES_ON_INPUT = [
    AIRCRAFT_COUNTABLE_TACH_TIME,
    AIRCRAFT_COUNTABLE_FLIGHT_TIME,
    AIRCRAFT_COUNTABLE_HOBBS_TIME,
    AIRCRAFT_COUNTABLE_LANDINGS,
    AIRCRAFT_COUNTABLE_CYCLES,
    AIRCRAFT_COUNTABLE_CYCLES_L,
    AIRCRAFT_COUNTABLE_CYCLES_R,
];
export const AIRCRAFT_IGNORED_CONSUMABLES_ON_DISPLAY = [
    AIRCRAFT_COUNTABLE_TACH_TIME,
    AIRCRAFT_COUNTABLE_FLIGHT_TIME,
    AIRCRAFT_COUNTABLE_HOBBS_TIME,
    AIRCRAFT_COUNTABLE_CYCLES,
    AIRCRAFT_COUNTABLE_CYCLES_L,
    AIRCRAFT_COUNTABLE_CYCLES_R,
];
//# sourceMappingURL=countables.js.map